module.exports = __webpack_public_path__ + "img/623-42dfb3.png";